import React from 'react'

class Tag extends React.Component {
	
	constructor(props) {
		super(props)
		this.removeTag = this.removeTag.bind(this)
	}
	
	removeTag() {
		const { index, removeTag } = this.props
		removeTag(index)
	}
	
	render() {	
		
		const { tag } = this.props
			
		return (
			<span className="tag">{ tag }<span onClick={ this.removeTag }>×</span></span>
		)
	}
}

export default Tag


// WEBPACK FOOTER //
// ./src/components/Editor/Tag.js